import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, computed } from "vue";

//- 初期費用

export default /*#__PURE__*/_defineComponent({
  name: 'VueSimulator',
  setup(__props, { expose }) {
  expose();

const initialCost = Number(498000);
//- 管理費用
const maintenanceCost = Number(360000);
//- 人口
const postPopulace = ref<number>();

//- postPopulaceの値が30までは掛ける1000円、31から40は掛ける1250円
const serverPrice = computed(() => {
    if (postPopulace.value < 1) {
        return false;
    }
    if (postPopulace.value >= 1 && postPopulace.value <= 30) {
        const t: Number = postPopulace.value * 100;
        return (50000 + postPopulace.value * 1000) * 12;
    } else if (postPopulace.value >= 31 && postPopulace.value <= 40) {
        return (50000 + postPopulace.value * 1250) * 12;
    } else {
        return false;
    }
});

const result = computed(() => {
    if (typeof serverPrice !== "boolean") {
        return initialCost + <number>serverPrice.value + maintenanceCost;
    }
    return false;
});

watch(postPopulace, (val) => {
    if (val) {
        const reg = /^[0-9]+$/;
        if (!reg.test(val)) {
            postPopulace.value = Number(val.replace(/[^0-9]/g, ""));
            // console.log(postPopulace.value)
        }
    }
});

const __returned__ = { initialCost, maintenanceCost, postPopulace, serverPrice, result, ref, watch, computed }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})